import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { useAuthStore } from '../../stores/auth/auth.store';
import MainMenu from '../menu/MainMenu';
import RenewTokenDialog from '../ui/RenewTokenDialog';

const styles = {
  fullHeight: {
    height: '100vh'
  },
  fullWidth: {
    width: '100vw'
  }
};

interface AppLayoutProps {
  user: string;
}

const AppLayout = (props: AppLayoutProps) => {
  const { expirationTime, user, renewDialogVisible, renewTimeFrame, showRenewDialog } =
    useAuthStore((state) => state);

  useEffect(() => {
    if (!expirationTime) return;

    const dateNow = Date.now();
    let timeToRenew = expirationTime - renewTimeFrame - dateNow;

    if (timeToRenew <= 0) {
      localStorage.removeItem('auth');
      window.location.replace('/login');
      return;
    }

    const timeout = setTimeout(() => {
      showRenewDialog();
    }, timeToRenew);

    return () => clearTimeout(timeout);
  }, [expirationTime]);

  return (
    <>
      <Grid container sx={styles.fullHeight} direction="column">
        <Grid size="grow">
          <Grid container sx={{...styles.fullWidth}} justifyContent="normal">
            <Grid size="grow">
              <MainMenu user={props.user} />
              <Grid container padding={2}>
                <Grid size="grow">
                  <Outlet />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {renewDialogVisible && (
        <RenewTokenDialog open={renewDialogVisible} refreshToken={user?.refreshToken ?? ''} />
      )}
    </>
  );
};

export default AppLayout;
